import React from 'react'
import { compose, pure } from 'recompose'
import { Link } from 'react-router-dom'
import styles from './introTextComponent.scss'
import PropTypes from 'prop-types'
export function IntroText (props: Props) {
  if (props.link) {
    return (
      <Link className={styles.introText} to={props.link}>
        {props.icon}
        {props.headerElement === 'h2'
          ? <h2 className={styles.pageIntroHeader}>
            {props.title}
          </h2>
          : <h1 className={styles.pageIntroHeader}>
            {props.title}
          </h1>}
        {props.description &&
          <p className={styles.pageIntroText}>
            {props.description}
          </p>}
        {props.children}
      </Link>
    )
  } else {
    return (
      <div className={styles.introText}>
        {props.icon}
        {props.headerElement === 'h2'
          ? <h2 className={styles.pageIntroHeader}>
            {props.title}
          </h2>
          : <h1 className={styles.pageIntroHeader}>
            {props.title}
          </h1>}
        {props.description &&
          <p className={styles.pageIntroText}>
            {props.description}
          </p>}
        {props.children}
      </div>
    )
  }
}
IntroText.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.any,
  link: PropTypes.string,
  icon: PropTypes.element,
  headerElement: PropTypes.string
}

export default compose(pure)(IntroText)



// WEBPACK FOOTER //
// ./src/components/introText/introTextComponent.js